import classnames from 'classnames'


const { createHigherOrderComponent } = wp.compose;
const { __ } = wp.i18n;
const { Fragment } = wp.element;
const { InspectorControls } = wp.blockEditor;
const { PanelBody, RangeControl, ToggleControl } = wp.components;

/**
 * Add spacing control attribute to block.
 *
 * @param {object} settings Current block settings.
 * @param {string} name Name of block.
 *
 * @return {object} Modified block settings.
 */
const paragraphStylesRegister = ( settings, name ) => {

	// Do nothing if it's another block than our defined ones.
	if ( name !== 'core/paragraph' ) {

		return settings;

	}

	settings.attributes = Object.assign( settings.attributes, {
		maxWidth: {
			type: 'number',
			default: 1100,
		},
		enableMaxWidth: {
			type: 'boolean',
			default: false,
		},
	} );

	return settings;

};

wp.hooks.addFilter(
	'blocks.registerBlockType',
	'wombat/paragraph/register/custom/style',
	paragraphStylesRegister
);

/**
 * Add Custom Settings
 * @param {Object} settings The block settings
 * @param {string} name The block name
 * @return {Object} The block settings
 */
const paragraphStylesEdit = createHigherOrderComponent( ( BlockEdit ) => {

	return ( props ) => {

		// Do nothing if it's another block than our defined ones.
		if ( props.name !== 'core/paragraph' ) {

			return (
				<BlockEdit {...props} />
			);

		}

		const { attributes, setAttributes } = props;

		return (
			<Fragment>
				<BlockEdit {...props} />
				<InspectorControls>
					<PanelBody title={__( 'Extra Settings' )}>
						<ToggleControl
							label={__( 'Enable max width', 'wombat' )}
							help={attributes.enableMaxWidth ? __( 'Max width is active', 'wombat' ) : __( 'Max width is default', 'wombat' )}
							checked={attributes.enableMaxWidth}
							onChange={() => setAttributes( { enableMaxWidth: !attributes.enableMaxWidth } )}
						/>
						{attributes.enableMaxWidth && (
							<RangeControl
								label={__( 'Max width (in px)' )}
								value={attributes.maxWidth}
								onChange={( value ) => setAttributes( { maxWidth: value } )}
								min={320}
								step={2}
								max={1100}
							/>
						)}
					</PanelBody>
				</InspectorControls>
			</Fragment>
		);

	};

}, 'paragraphStylesEdit' );

wp.hooks.addFilter(
	'editor.BlockEdit',
	'wombat/paragraph/edit/custom/style',
	paragraphStylesEdit
);


/**
 * Add custom class to block in Edit
 *
 * @param {string} BlockListBlock
 * @param {string} paragraphStylesList
 *
 * @return {object}
 */
const paragraphStylesList = createHigherOrderComponent( ( BlockListBlock ) => {

	return ( props ) => {

		// If current block is not allowed
		if ( props.name !== 'core/paragraph' ) {

			return (
				<BlockListBlock {...props} />
			);

		}

		const { className, attributes } = props;

		const extraClasses = classnames(
			className,
			{ 'has-max-width' : attributes.enableMaxWidth }
		)
		const wrapperProps = {
			...props.wrapperProps,
			'style': attributes.enableMaxWidth ? { '--p-max-width': `${attributes.maxWidth}px` } : undefined,
			'className': extraClasses
		};

		return <BlockListBlock
			{...props} wrapperProps={wrapperProps}
		/>

	};

}, 'paragraphStylesList' );

wp.hooks.addFilter(
	'editor.BlockListBlock',
	'wombat/paragraph/list/custom/style/',
	paragraphStylesList
);

/**
 * Add margin style attribute to save element of block.
 *
 * @param {object} saveElementProps Props of save element.
 * @param {Object} blockType Block type information.
 * @param {Object} attributes Attributes of block.
 *
 * @return {object} Modified props of save element.
 */
const paragraphStylesSave = ( saveElementProps, blockType, attributes ) => {

	if ( blockType.name !== 'core/paragraph' ) {

		return saveElementProps;

	}

	if ( attributes.enableMaxWidth && attributes.maxWidth ) {

		if( !saveElementProps.style ) {

			saveElementProps.style = {};

		}
		saveElementProps.style['--p-max-width'] = `${attributes.maxWidth}px`;

	}

	return saveElementProps;

};

wp.hooks.addFilter(
	'blocks.getSaveContent.extraProps',
	'wombat/paragraph/save/custom/style',
	paragraphStylesSave
);

